import axios from 'axios';
import FormData from 'form-data';
import {
  V1_BUNDLE_PACKAGE,
  GET_INTERSECT_SALES_TYPES,
  GET_UNION_ITEM_NAMES,
  GET_UNION_ITEM_VARIANT_NAMES,
  UPLOAD_BUNDLE_PACKAGE_IMAGE,
  CREATE_BUNDLE_PACKAGE,
  UPDATE_BUNDLE_PACKAGE,
  DELETE_BUNDLE_PACKAGE,
  GET_UPDATE_STATUS_BUNDLE,
} from './constants';

function handleApiErrorResponse(e) {
  if (e.response) {
    const { data } = e.response;
    throw new Error(data.message);
  }
  throw e;
}

export function getBundlePackages(args?) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const params: any = { per_page: 35 };
  const headers: any = {};
  if (args?.nextCursor) {
    params.cursor = args.nextCursor;
  }
  if (args?.filters?.outletId > 0) {
    headers.outlet_id = args.filters.outletId;
  }

  return axios
    .get(V1_BUNDLE_PACKAGE, {
      params,
      headers,
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function getBundlePackageDetail(bundleId) {
  return axios
    .get(DELETE_BUNDLE_PACKAGE(bundleId), {
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function getIntersectSalesTypes(args) {
  const { assignedOutletIds } = args;

  return axios
    .get(GET_INTERSECT_SALES_TYPES, {
      headers: { OUTLET_ID: assignedOutletIds },
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function getUnionItemNames(args) {
  const { assignedOutletIds } = args;

  const params: any = {};
  params.page = args.page || 1;
  params.keyword = args.searchKeyword || '';

  return axios
    .get(GET_UNION_ITEM_NAMES, {
      headers: { OUTLET_ID: assignedOutletIds },
      params,
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function getUnionItemVariantNames(args) {
  const { assignedOutletIds, itemName, page } = args;
  const params = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    item_name: itemName,
    page,
  };

  return axios
    .get(GET_UNION_ITEM_VARIANT_NAMES, {
      params,
      headers: { OUTLET_ID: assignedOutletIds },
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function deleteBundlePackage(bundleId) {
  return axios
    .delete(`${V1_BUNDLE_PACKAGE}/${bundleId}`, {
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function uploadBundleImage(image) {
  const form = new FormData();
  form.append('image', image);

  return axios.post(UPLOAD_BUNDLE_PACKAGE_IMAGE, form, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'content-type': 'multipart/form-data',
    },
    withCredentials: true,
  });
}

export function createBundle(bundle) {
  return axios
    .post(CREATE_BUNDLE_PACKAGE, bundle, {
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function updateBundle(bundle) {
  return axios
    .put(UPDATE_BUNDLE_PACKAGE(bundle.id), bundle, {
      withCredentials: true,
    })
    .catch(handleApiErrorResponse);
}

export function updateBundleStatus(bundleId, isActive) {
  return axios.patch(
    GET_UPDATE_STATUS_BUNDLE(bundleId),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    { is_active: isActive },
    {
      withCredentials: true,
    }
  );
}
